import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.xpherium.com/api';

export const PENDING_BILLING_INTENT_KEY = 'xpherium:pending-billing-intent';
export const PENDING_INVITE_PROMPT_KEY = 'xph_pending_invite_prompt';

const getStoredToken = () => localStorage.getItem('token') || localStorage.getItem('auth_token') || '';

/**
 * Send the user straight to Stripe Checkout (setup mode) with upgrade
 * intent round-tripped via sessionStorage + return URL params.
 */
export async function startStripeSetupForUpgrade({
  product,
  planId,
  planName,
  billingCycle,
  returnPath,
}) {
  const resumePayload = {
    resumeIntent: 'upgrade',
    resumePlan: planId,
    resumeCycle: billingCycle,
  };

  const resolvedReturnPath = returnPath || (typeof window !== 'undefined' ? window.location.pathname : '/subscription');

  try {
    sessionStorage.setItem(
      PENDING_BILLING_INTENT_KEY,
      JSON.stringify({
        ...resumePayload,
        product,
        planId,
        planName: planName || planId,
        billingCycle,
        createdAt: Date.now(),
        returnPath: resolvedReturnPath,
      })
    );
  } catch {
    // sessionStorage quota errors are non-fatal — URL round-trip still works.
  }

  const res = await axios.post(
    `${API_URL}/subscriptions/setup-checkout`,
    {
      product,
      ...resumePayload,
      returnPath: resolvedReturnPath,
    },
    { headers: { Authorization: `Bearer ${getStoredToken()}` } }
  );

  if (res.data?.url) {
    window.location.href = res.data.url;
    return true;
  }

  throw new Error('No checkout URL returned');
}

// ── Post-upgrade team-invite prompt ─────────────────────────────────
// When a free account upgrades to a plan with multiple seats, we prompt
// them once to invite coworkers. UpgradePopup completes the upgrade and
// then navigates to /subscription, so the flag round-trips through
// sessionStorage and SubscriptionManagement consumes it on arrival.
export function markPendingInvitePrompt() {
  try {
    sessionStorage.setItem(PENDING_INVITE_PROMPT_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}

export function consumePendingInvitePrompt() {
  try {
    const pending = sessionStorage.getItem(PENDING_INVITE_PROMPT_KEY);
    if (pending) sessionStorage.removeItem(PENDING_INVITE_PROMPT_KEY);
    return Boolean(pending);
  } catch {
    return false;
  }
}

export function subscriptionReturnPath(product) {
  if (product === 'intelligence-navigator') return '/subscription';
  if (product === 'autopilot') return '/app/autopilot/subscription';
  if (product === 'knowledge-iq') return '/app/knowledge-iq/subscription';
  if (product === 'data-iq') return '/app/data-iq/subscription';
  return '/subscription';
}
